import { PromotionBanner } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { ReferralBonusTypes } from "@src/appV2/Accounts/WorkerReferrals/types";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useHistory } from "react-router-dom";

import { useGetReferrals } from "../api/useGetReferrals";
import { WORKER_REFERRALS_MY_REFERRALS_PATH_FULL } from "../path";

export function ActiveReferralBanner() {
  const history = useHistory();

  const { data: referrals } = useGetReferrals({});

  const unpaidReferralActivationBonus = referrals?.find(
    (referral) => !referral.bonusPaid && referral.bonusType === ReferralBonusTypes.ACTIVATION
  );

  if (isDefined(unpaidReferralActivationBonus)) {
    const { bonusExpectationMessage, bonusValue } = unpaidReferralActivationBonus;

    return (
      <PromotionBanner
        title={`Your $${bonusValue} bonus awaits!`}
        subtitle={`You and your friend will get rewarded ${
          bonusExpectationMessage?.toLowerCase() ?? "after you finish your first shift"
        }.`}
        icon="gift-lavender-colored"
        backgroundColor={(theme) => theme.palette.common.white}
        borderColor={(theme) => theme.palette.intent?.neutral.gradient ?? theme.palette.info.main}
        borderVariant="gradient"
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.ACTIVE_REFERRAL_BANNER_CLICKED);
          history.push(WORKER_REFERRALS_MY_REFERRALS_PATH_FULL);
        }}
      />
    );
  }

  return null;
}
